import Immutable from 'seamless-immutable';
import { normalize } from 'normalizr';
import pubnub from '../../pubnub';
import schema from '../../schema';

import ActionTypes from './actionTypes';

const Actions = {
  creators: {
    receivedMessage: data => ({
      data,
      type: ActionTypes.RECEIVED_MESSAGE,
    }),
    subscribedChannel: data => ({
      data,
      type: ActionTypes.SUBSCRIBED_CHANNEL,
    }),
    unsubscribedChannel: data => ({
      data,
      type: ActionTypes.UNSUBSCRIBED_CHANNEL,
    }),
    unsubscribedChannels: () => ({
      type: ActionTypes.UNSUBSCRIBED_CHANNELS,
    }),
    presenceUpdate: data => ({
      data,
      type: ActionTypes.PRESENCE_UPDATE,
    }),
  },
  thunks: {
    subscribe: channels => dispatch => {
      pubnub.subscribe({ channels, withPresence: true });
      const data = channels.map(channelId => {
        return { channelId, messages: [] };
      });
      const results = normalize(data, schema.CHANNELS);
      dispatch(Actions.creators.subscribedChannel(results));
    },
    unsubscribe: channels => {
      pubnub.unsubscribe({ channels });
    },
    unsubscribeFromAll: () => dispatch => {
      pubnub.unsubscribeAll();
      dispatch(Actions.creators.unsubscribedChannels());
    },
  },
};

export { Actions };

const defaultState = Immutable({});

export default (state = defaultState, action) => {
  if (action.type === ActionTypes.SUBSCRIBED_CHANNEL) {
    return state.merge(action.data.entities.channels);
  } else if (action.type === ActionTypes.RECEIVED_MESSAGE) {
    const { entities, result } = action.data;
    const message = entities.messages[result];
    const { channelId } = message;
    return state.updateIn([channelId, 'messages'], list =>
      Array.from(new Set(list.concat(result))),
    );
  } else if (action.type === ActionTypes.RECEIVED_MESSAGES) {
    const { entities, result } = action.data;
    if (entities.messages) {
      const messageId = result[0];
      const channelId = entities.messages[messageId].channelId;
      return state.updateIn([channelId, 'messages'], list =>
        Array.from(new Set(list.concat(result))),
      );
    }
  } else if (action.type === ActionTypes.SEND_NEW_MESSAGE) {
    const { entities, result } = action.data;
    const message = entities.messages[result];
    const { channelId } = message;
    return state.updateIn([channelId, 'messages'], list => list.concat(result));
  } else if (action.type === ActionTypes.PRESENCE_UPDATE) {
    const { name, occupancy } = action.data;
    return state.updateIn([name, 'presence', 'occupancy'], () => occupancy);
  } else if (action.type === ActionTypes.UNSUBSCRIBED_CHANNELS) {
    return defaultState;
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/ducks/chat/channels.js